var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7113 8.86067H32.2862V11.1407H34.5662V13.4357H36.8612V18.0107H39.1413V29.4257H36.8612V34.0007H34.5662V36.2957H32.2862V38.5757H27.7113V40.8557H16.2812V43.1507H32.2862V40.8557H36.8612V38.5757H39.1413V36.2957H41.4363V34.0007H43.7163V29.4257H45.9963V18.0107H43.7163V13.4357H41.4363V11.1407H39.1413V8.86067H36.8612V6.58067H32.2862V4.28568H16.2812V6.58067H27.7113V8.86067Z",
    fill: "#FBC04E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8614 18.0106H34.5664V29.4256H36.8614V18.0106Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5661 29.4257H32.2861V31.7207H34.5661V29.4257Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5661 15.7156H32.2861V18.0106H34.5661V15.7156Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2868 31.7207H30.0068V34.0007H32.2868V31.7207Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2868 13.4357H30.0068V15.7157H32.2868V13.4357Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0069 34.0008H27.7119V36.2958H30.0069V34.0008Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0069 11.1407H27.7119V13.4357H30.0069V11.1407Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7113 36.2957H16.2812V38.5757H27.7113V36.2957Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7116 24.8657H25.4316V29.4257H27.7116V24.8657Z",
    fill: "#FBC04E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7116 18.0106H25.4316V20.2906H27.7116V18.0106Z",
    fill: "#FBC04E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7113 8.86069H16.2812V11.1407H27.7113V8.86069Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8562 31.7207V34.0007H23.1362V31.7207H25.4312V29.4257H23.1362V24.8657H25.4312V22.5707H23.1362V18.0107H25.4312V15.7157H23.1362V13.4357H20.8562V15.7157H18.5762V18.0107H20.8562V22.5707H18.5762V24.8657H20.8562V29.4257H18.5762V31.7207H20.8562Z",
    fill: "#FBC04E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5762 27.1457H16.2812V29.4257H18.5762V27.1457Z",
    fill: "#FBC04E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5762 18.0106H16.2812V22.5706H18.5762V18.0106Z",
    fill: "#FBC04E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2817 38.5757H11.7217V40.8557H16.2817V38.5757Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.281 34.0008H14.001V36.2958H16.281V34.0008Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.281 11.1407H14.001V13.4357H16.281V11.1407Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2817 6.58066H11.7217V8.86066H16.2817V6.58066Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0017 31.7207H11.7217V34.0007H14.0017V31.7207Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0017 13.4357H11.7217V15.7157H14.0017V13.4357Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7208 36.2957H9.42578V38.5757H11.7208V36.2957Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7208 29.4257H9.42578V31.7207H11.7208V29.4257Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7208 15.7156H9.42578V18.0106H11.7208V15.7156Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7208 8.86069H9.42578V11.1407H11.7208V8.86069Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42648 34.0008H7.14648V36.2958H9.42648V34.0008Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42648 18.0106H7.14648V29.4256H9.42648V18.0106Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42648 11.1406H7.14648V13.4356H9.42648V11.1406Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14559 29.4257H4.85059V34.0007H7.14559V29.4257Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14559 13.4357H4.85059V18.0107H7.14559V13.4357Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85129 18.0106H2.57129V29.4256H4.85129V18.0106Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.63142377374d9bbbc6e666562fb43d0f.svg";
export { ForwardRef as ReactComponent };